// let BASE_URL = 'http://localhost:5000';
let BASE_URL = 'http://192.168.43.3:5000';
// let BASE_URL = 'http://192.168.137.225:5000';

// let BASE_PATH = 'http://localhost:3000';
let BASE_PATH = 'http://192.168.43.3:5000';
// let BASE_PATH = 'http://192.168.137.225:5000';

module.exports = { BASE_URL, BASE_PATH };
